import React from 'react'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'

/**
 * @component
 * @param {React.ReactNode} props.children - The element that triggers the tooltip
 * @param {string} [props.tooltip=''] - The content of the tooltip
 * @param {string} [props.placement='top'] - Position of the tooltip relative to the target element
 *   (one of 'top', 'right', 'bottom', 'left')
 * @param {Object} [props.delay={ show: 250, hide: 400 }] - Delay showing and hiding the tooltip (ms)
 * @param {Array<string>} [props.trigger=['hover', 'focus']] - Array of event types to trigger tooltip
 */

const CustomTooltip = ({
  children,
  tooltip = '',
  placement = 'top',
  delayShow = 250,
  delayHide = 400,
  trigger = ['hover', 'focus'],
  id = 'custom-tooltip',
  className = '',
}) => (
  <OverlayTrigger
    placement={placement}
    delayShow={delayShow}
    delayHide={delayHide}
    overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
    trigger={trigger}
  >
    <span className={className}>{children}</span>
  </OverlayTrigger>
)

export default CustomTooltip
